export default "__VITE_ASSET__DFgy9xPU__"